module.exports = __webpack_public_path__ + "static/img/image077.f090bca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image077.png
// module id = r0hU
// module chunks = 1